import styled from 'styled-components';

export const ContainerStyled = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
